import React from 'react'
import { Helmet } from 'react-helmet-async'
import FAQContent from '../components/faq/FAQContent'

export default function FAQ() {
  return (
    <>
      <Helmet>
        <title>FAQ - A Plus A Driving School</title>
        <meta name="description" content="Frequently asked questions about our driving programs, registration, pricing, and more." />
      </Helmet>
      <FAQContent />
    </>
  )
}

